<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="closeShare">Close</ion-button>
        </ion-buttons>
        <ion-title>Share Form</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding text-center>
      <div id="container">
        <qrcode-vue :value="value" :size="size" level="H" className="qrcode" v-if="value && size > 0"></qrcode-vue>
        <ion-button class="link" color="primary" fill="outline" expand="block" @click="openSpreadsheet()" v-if="form">Open Google Spreadsheet</ion-button>
      </div>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import QrcodeVue from "qrcode.vue";
export default {
  name: "form-share",
  mixins: [Helpers],
  components: {
    QrcodeVue
  },
  props: ["form"],
  data() {
    return {
      value: "",
      size: "0"
    };
  },
  created() {
    this.value = this.form.url;
    // this.value = JSON.stringify({
    //   id: this.form.id,
    //   key: this.form.key,
    //   url: this.form.url,
    //   title: this.form.title,
    //   description: this.form.description
    // });
  },
  mounted() {
    setTimeout(() => {
      let container = document.querySelector("#container");
      this.size = "" + container.offsetWidth;
    }, 1000);
  },
  methods: {
    closeShare() {
      this.hideModal();
    },
    openSpreadsheet() {
      this.openUrl(this.form.url);
    }
  }
};
</script>

<style scoped>
#container {
  max-width: 90%;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.link {
  margin-top: 20px;
  width: 100%;
}
</style>
